// Pendiente de revisar
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export class UserProfileDto extends ItiBaseDto {
	public userId: string;
	public firstName: string;
	public lastName: string;
	public email: string;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
	}
}
